import { render, staticRenderFns } from "./DataviewEdit.vue?vue&type=template&id=17633ab1"
import script from "./DataviewEdit.vue?vue&type=script&lang=js"
export * from "./DataviewEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports